export default __webpack_public_path__ + "static/char-s-55-zh-Hant-62c135e0790634d1e37b6649461a6c84.webp";